/**
 * What every plan includes (PLANES, Jorge and Daniel 2026-09-30).
 *
 * The three plans sell the same product and differ ONLY in quotes a month,
 * which the card shows as its hero number straight from `/billing/config`
 * (platform_config `quotes_month_<plan>`). So there is one list, identical on
 * every card, with nothing muted and nothing per tier — the matrix this file
 * used to hold (visibility, custom push, portfolio from Pro, landing page and
 * FixyTerminal from Master) described differences that no longer exist.
 *
 * Deliberately absent: Spotlight (unchanged in code, advertised on no plan)
 * and FixyTerminal (out of scope). Every label is an i18n key under
 * `planFeatures`. `backend/services/rag/plan_copy.py` mirrors these keys for
 * Dany's corpus, and smoke_rag compares the two.
 */
export const PLAN_FEATURES = [
  { id: "danyTextVoice", labelKey: "danyTextVoice" },
  { id: "push", labelKey: "push" },
  { id: "portfolio", labelKey: "portfolio" },
  { id: "fixymatch", labelKey: "fixymatch" },
];

export default PLAN_FEATURES;
